import "./EngineControl.css";
import engineBackground from "../assets/engine.png";
import engineOnImage from "../assets/engine_on.png";
import engineOffImage from "../assets/engine_off.png";

interface EngineControlProps {
  engineOn: boolean;
  onToggle: () => void;
}

export function EngineControl({ engineOn, onToggle }: EngineControlProps) {
  return (
    <div
      className="engine-control"
      onClick={onToggle}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onToggle();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={engineOn ? "Turn engine off" : "Turn engine on"}
    >
      <div className="engine-control__container">
        <img
          className="engine-control__background"
          src={engineBackground}
          alt="Engine control"
        />
        <img
          className="engine-control__lever"
          src={engineOn ? engineOnImage : engineOffImage}
          alt={engineOn ? "Engine on" : "Engine off"}
        />
      </div>
    </div>
  );
}
